// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"4001e3d2","242":"2fa5f89c","667":"4921a177","794":"d073ebc7","972":"c87af843"}[chunkId] + ".chunk.js";
};